import React, { Component } from "react";
import currencyFormatter from "currency-formatter";
import Box from "grommet/components/Box";
import Heading from "grommet/components/Heading";
import Value from "grommet/components/Value";
import AppSettings from "../../utils/appSettings";

export default class Total extends Component {
  render() {
    return (
      <Box margin={{vertical: 'small'}} responsive={false} direction="row" justify="between" align="center" flex={true}>
        <Heading tag={this.props.big ? "h3" : "h4"} strong uppercase style={{margin: 0}}>{this.props.label ? this.props.label : 'Provision:'}</Heading>
        <Value
          value={currencyFormatter.format(this.props.total, AppSettings.currencyOptionFormater)}
          units="€"
          size={this.props.big ? "small" : "small"}
        />
      </Box>
    );
  }
}



// WEBPACK FOOTER //
// ./src/computationApps/components/viewer/total.js